@let show = filtersToShow();

<form [formGroup]="filterService.query_fg" [class]="containerClass()">
  <ng-content></ng-content>

  <div class="flex flex-1 flex-wrap items-end gap-x-3 gap-y-3">
    @if (show.includes('regions')) {
    <div class="flex flex-col gap-1.5 w-full sm:w-auto">
      <label class="text-xs font-bold text-slate-500 uppercase tracking-wider flex items-center gap-1">
        Regions @if (showNetInterconnectorsInfo()) {
        <i
          class="pi pi-info-circle text-indigo-400 cursor-help"
          [pTooltip]="netInterconnectorsInfo"
          [escape]="false"></i>
        }
      </label>
      <p-multiSelect
        (onPanelHide)="fixbodyscroll('onhide', 'regions')"
        (onPanelShow)="fixbodyscroll('onshow', 'regions')"
        formControlName="regions"
        [filter]="false"
        [options]="regions"
        appendTo="body"
        defaultLabel="Select Regions"
        display="chip"
        optionLabel="name"
        optionValue="id"
        styleClass="w-full sm:w-[12rem]">
      </p-multiSelect>
    </div>
    } @if (show.includes('single_region')) {
    <div class="flex flex-col gap-1.5 w-full sm:w-auto">
      <label class="text-xs font-bold text-slate-500 uppercase tracking-wider">Region</label>
      <p-select
        (onHide)="fixbodyscroll('onhide', 'region')"
        (onShow)="fixbodyscroll('onshow', 'region')"
        formControlName="region"
        [filter]="false"
        [options]="regions"
        appendTo="body"
        placeholder="Select a Region"
        optionLabel="name"
        optionValue="id"
        styleClass="w-full sm:w-[12rem]">
      </p-select>
    </div>
    } @if (show.includes('advanced')) {
    <div class="flex flex-col gap-1.5 w-full sm:w-auto">
      <label class="text-xs font-bold text-slate-500 uppercase tracking-wider">Primary Source / Tech</label>
      <p-multiSelect
        (onPanelHide)="fixbodyscroll('onhide', 'fuelSources')"
        (onPanelShow)="fixbodyscroll('onshow', 'fuelSources')"
        formControlName="fuel_sources"
        [filter]="false"
        [options]="$any(filterService.fuelSourcesOptions$ | async)"
        appendTo="body"
        defaultLabel="Select Fuel sources"
        display="chip"
        styleClass="w-full sm:w-[13rem]">
      </p-multiSelect>
    </div>

    @if (show.includes('advanced:full')) {
    <div class="flex flex-col gap-1.5 w-full sm:w-auto">
      <label class="text-xs font-bold text-slate-500 uppercase tracking-wider flex items-center justify-between">
        <span>Stations</span>
        @if (stationDates(); as dates) {
        <span
          class="text-[10px] text-indigo-500 bg-indigo-50 px-2 py-0.5 rounded cursor-help"
          [escape]="false"
          [pTooltip]="stationsDateInfo">
          {{ dates.min | date : 'dd/MM/yy' }} - {{ dates.max | date : 'dd/MM/yy' }}
        </span>
        }
      </label>

      <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <p-multiSelect
          (onPanelHide)="fixbodyscroll('onhide', 'stations')"
          (onPanelShow)="fixbodyscroll('onshow', 'stations')"
          formControlName="stations"
          [filter]="true"
          [options]="stationOptions()"
          appendTo="body"
          dataKey="name"
          defaultLabel="Search stations..."
          display="chip"
          optionLabel="name"
          styleClass="w-full sm:w-[15rem]">
          <ng-template let-station pTemplate="item">
            <div
              class="flex flex-col gap-2 w-full border-b border-slate-50 pb-2 mb-1 last:border-0 last:pb-0 last:mb-0">
              <div class="flex items-center justify-between">
                <span class="font-bold text-sm text-slate-700">{{ station.name }}</span>
                <span
                  class="text-[10px] border border-indigo-100 text-indigo-500 bg-indigo-50/50 px-1.5 py-0.5 rounded">
                  Updated: {{ station.last_changed | date : 'dd/MM/yy' }}
                </span>
              </div>
              <div class="flex items-center justify-between mt-1">
                <div class="flex flex-wrap gap-1">
                  @for (duid of station.duids; track duid.name) {
                  <span class="bg-slate-100 text-[10px] text-slate-600 border border-slate-200 px-1.5 py-0.5 rounded">
                    {{ duid.name }}
                  </span>
                  }
                </div>
                @if (station.duids.length > 1) {
                <div class="scale-90 origin-right" (click)="$event.stopPropagation()">
                  <p-selectButton
                    (onChange)="stationsOnChange($event)"
                    [(ngModel)]="station.grouped"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="!isSelected(station.name)"
                    [options]="[
                      { label: 'Grouped', value: true },
                      { label: 'Individual', value: false }
                    ]"
                    optionLabel="label"
                    optionValue="value">
                  </p-selectButton>
                </div>
                }
              </div>
            </div>
          </ng-template>
        </p-multiSelect>

        <div
          class="flex items-center gap-2 px-3 py-2.5 bg-slate-50 border border-slate-200 rounded-lg hover:bg-indigo-50 hover:border-indigo-200 transition-colors cursor-pointer w-full sm:w-auto h-[42px]">
          <p-checkbox formControlName="aggr_by_fuel_sources" [binary]="true" inputId="aggrByFuelSources"></p-checkbox>
          <label for="aggrByFuelSources" class="text-sm font-medium text-slate-700 cursor-pointer whitespace-nowrap"
            >Aggregate sources</label
          >
        </div>
      </div>
    </div>
    } } @if (show.includes('interconnectors')) {
    <div class="flex flex-col gap-1.5 w-full sm:w-auto">
      <label class="text-xs font-bold text-slate-500 uppercase tracking-wider flex items-center gap-1">
        Interconnectors @if (showInterconnectorsInfo()) {
        <i class="pi pi-info-circle text-indigo-400 cursor-help" [pTooltip]="interconnectorsInfo" [escape]="false"></i>
        }
      </label>
      <p-multiSelect
        (onPanelHide)="fixbodyscroll('onhide', 'interconnectors')"
        (onPanelShow)="fixbodyscroll('onshow', 'interconnectors')"
        formControlName="interconnectors"
        [filter]="false"
        [options]="interConnectors"
        appendTo="body"
        defaultLabel="Select Interconnectors"
        display="chip"
        optionLabel="name"
        optionValue="id"
        styleClass="w-full sm:w-[12rem]">
      </p-multiSelect>
    </div>
    } @if (show.includes('range')) {
    <div class="flex flex-col gap-1.5 w-full sm:w-auto">
      <label class="text-xs font-bold text-slate-500 uppercase tracking-wider flex items-center gap-1">
        Date Range @if (showRangeInfo()) {
        <i class="pi pi-info-circle text-indigo-400 cursor-help" [escape]="false" [pTooltip]="dateRangeInfo"></i>
        }
      </label>

      <div
        class="flex items-center bg-white border border-slate-300 rounded-lg focus-within:ring-1 focus-within:ring-indigo-500 focus-within:border-indigo-500 transition-shadow">
        <p-datepicker
          formControlName="range_from"
          appendTo="body"
          dataType="string"
          dateFormat="dd/mm/yy"
          placeholder="From"
          styleClass="w-full sm:w-[7.5rem] nem-range-calendar">
        </p-datepicker>

        <div class="px-2 text-slate-400 bg-slate-50 h-[40px] flex items-center border-x border-slate-200">
          <i class="pi pi-arrow-right text-xs"></i>
        </div>

        <p-datepicker
          formControlName="range_to"
          appendTo="body"
          dataType="string"
          dateFormat="dd/mm/yy"
          placeholder="To"
          styleClass="w-full sm:w-[7.5rem] nem-range-calendar">
        </p-datepicker>
      </div>
    </div>
    } @if (show.includes('frequency')) {
    <div class="flex flex-col gap-1.5 w-full sm:w-auto">
      <label class="text-xs font-bold text-slate-500 uppercase tracking-wider">Frequency</label>
      <p-select
        (onHide)="fixbodyscroll('onhide', 'frequency')"
        (onShow)="fixbodyscroll('onshow', 'frequency')"
        formControlName="frequency"
        [options]="dataFrequency"
        [showClear]="false"
        appendTo="body"
        placeholder="Select Frequency"
        optionLabel="name"
        optionValue="id"
        styleClass="w-full sm:w-[10rem]">
      </p-select>
    </div>
    }
  </div>
  <div
    class="flex-shrink-0 mt-4 md:mt-0"
    [ngClass]="{ 'ml-auto': isHorizontalLayout(), 'w-full': !isHorizontalLayout() }">
    <p-button
      label="Load Data"
      icon="pi pi-sync"
      [loading]="loading()"
      (onClick)="filtersSubmit($event)"
      styleClass="w-full bg-indigo-600 border-indigo-600 hover:bg-indigo-700 text-white shadow-md shadow-indigo-500/20 transition-all font-semibold py-2.5 px-6 rounded-lg">
    </p-button>
  </div>
</form>
